// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__37Ex6","modalFooterButton":"ModalNotes_modalFooterButton__OROpq"};